import React from 'react'

const AddNewGreen = (props:any) => {
  return (
    <svg width={22} height={22} fill="none" {...props}>
    <path
      stroke="#23B339"
      d="M11 20.166c5.042 0 9.167-4.125 9.167-9.166 0-5.042-4.125-9.167-9.166-9.167-5.042 0-9.167 4.125-9.167 9.167 0 5.041 4.125 9.166 9.167 9.166ZM7.334 11h7.333M11 14.666V7.333"
    />
  </svg>
  )
}

export default AddNewGreen